<template>
  <div>
    <b-container fluid>
      <h1>設計済プロパティ</h1>
      <b-row>
        <button
          class="btn btn-outline-secondary"
          @click="displayProperty"
        >表示</button>
        <button
          class="btn btn-outline-secondary"
          @click="downloadsCSV"
        >DL</button>
      </b-row>
      <b-row>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          aria-controls="property-design-table"
        ></b-pagination>
      </b-row>
      <b-table
        id="property-design-table"
        :fields="fields"
        :items="items"
        :current-page="currentPage"
        :per-page="perPage"
        bordered
        small
        responsive
      >
        <template v-slot:cell(no)="data">
          <div>
            {{ (currentPage - 1)* perPage + data.index + 1 }}
          </div>
        </template>
      </b-table>
    </b-container>
  </div>
</template>
<script>
import { API, graphqlOperation } from 'aws-amplify'
import { mapState } from 'vuex'
export default {
  name: 'PropertyList',
  data () {
    return {
      displayPropertyTable: false,
      currentPage: 1,
      perPage: 100,
      fields: [
        {
          key: 'no',
          label: '番号',
          sortable: true
        },
        {
          key: 'function_class',
          label: 'システム機能分類',
          sortable: true
        },
        {
          key: 'communication_trigger',
          label: '通信トリガ',
          sortable: true
        },
        {
          key: 'frame_type',
          label: 'フレーム種別',
          sortable: true
        },
        {
          key: 'design_sender',
          label: '設計用送信元',
          sortable: true
        },
        {
          key: 'design_destination',
          label: '設計用送信先',
          sortable: true
        },
        {
          key: 'destination_integration',
          label: '宛先結合',
          sortable: true
        },
        {
          key: 'property_name',
          label: 'プロパティ名称',
          sortable: true
        },
        {
          key: 'property_size',
          label: 'プロパティサイズ',
          sortable: true
        },
        {
          key: 'simultaneous_acquisition_property_name',
          label: '同時取得プロパティ',
          sortable: true
        },
        {
          key: 'actual_frequency',
          label: '実通信頻度',
          sortable: true
        }
      ],
      items: []
    }
  },
  computed: {
    totalRows () {
      return this.items.length
    },
    ...mapState(['version'])
  },
  methods: {
    async downloadsCSV () {
      const target = this.items
      let csv = '\ufeff' + this.fields.map(function (elm) { return elm.label }).join(',') + '\n'
      target.forEach(function (elm, idx) {
        this.fields.forEach(function (head, index) {
          if (head.key === 'no') {
            csv += idx + 1
          } else {
            if (elm[head.key] === null) {
              csv += ''
            } else {
              csv += elm[head.key]
            }
          }
          if (this.fields.length - 1 === index) {
            csv += '\n'
          } else {
            csv += ','
          }
        }.bind(this))
      }.bind(this))
      let blob = new Blob([csv], { type: 'text/csv' })
      let link = document.createElement('a')
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, 'PropertyTable.csv')
      } else {
        link.href = window.URL.createObjectURL(blob)
        link.download = 'PropertyTable.csv'
        link.click()
        this.all_loading = false
      }
    },
    async displayProperty () {
      try {
        await this.getProperties()
      } catch (e) {
        this.makeToast('失敗', '予期せぬエラーが発生しました。', 'danger')
        this.$log.debug(e)
      }
    },
    async getProperties () {
      let nextToken = null
      do {
        const result = await API.graphql(graphqlOperation(`
          query getLatestDesign{
            getLatestDesign(version: "${this.version}"){
              job_id
              version
              status
              property_design (
                ${nextToken === null ? 'nextToken: null' : `nextToken: "${nextToken}"`}
              ) {
                items {
                  function_class
                  communication_trigger
                  frame_type
                  design_sender
                  design_destination
                  destination_integration
                  property_name
                  property_size
                  simultaneous_acquisition_property_name
                  actual_frequency
                }
                nextToken
              }
            }
          }
        `))
        this.$log.debug(result)
        if (result.data.getLatestDesign.property_design.items.length === 0) {
          this.makeToast('失敗', '表示するデータがありません。', 'danger')
        } else {
          result.data.getLatestDesign.property_design.items.forEach(function (elm) {
            for (const key in elm) {
              if (key === 'destination_integration') {
                if (elm[key] === true) {
                  elm[key] = 'あり'
                }
                if (elm[key] === false) {
                  elm[key] = 'なし'
                }
              }
              if (key === 'actual_frequency') {
                if (elm[key] === 1) {
                  elm[key] = '最短'
                } else if (elm[key] === 60) {
                  elm[key] = '1分'
                } else if (elm[key] === 3600) {
                  elm[key] = '1時間'
                } else if (elm[key] === 86400) {
                  elm[key] = '1日'
                } else if (elm[key] === 2592000) {
                  elm[key] = '1ヶ月'
                } else if (elm[key] === 31536000) {
                  elm[key] = '1年'
                } else {
                  elm[key] = 'その他'
                }
              }
            }
          })
          this.items = this.items.concat(result.data.getLatestDesign.property_design.items)
        }
        nextToken = result.data.getLatestDesign.property_design.nextToken
      } while (nextToken !== null)
    }
  }
}
</script>
